jQuery(document).ready(function( $ ){
	// START JQUERY

	logit = (typeof logit !== 'undefined')? logit : false;

	videoloop_enable = (typeof videoloop_enable !== 'undefined')? videoloop_enable : false;
	videoloop_id = (typeof videoloop_id !== 'undefined')? videoloop_id : "videoloop-player";

	videoloop_skip_last = (typeof videoloop_skip_last !== 'undefined')? videoloop_skip_last :  1; // min 1
	videoloop_skip_first = (typeof videoloop_skip_first !== 'undefined')? videoloop_skip_first :  1;

	videofix_autoplay_enable = (typeof videofix_autoplay_enable !== 'undefined')? videofix_autoplay_enable :  true;
	videofix_autoplay_target = (typeof videofix_autoplay_target !== 'undefined')? videofix_autoplay_target :  'videoloop-player';
	videofix_autoplay_click_id = (typeof videofix_autoplay_click_id !== 'undefined')? videofix_autoplay_click_id :  'mainNavbar';

	videoplay_id = (typeof videoplay_id !== 'undefined')? videoplay_id :  '.play';
	videoplay_switch = (typeof videoplay_switch !== 'undefined')? videoplay_switch :  '.play_switch';
  videoplay_target = (typeof videoplay_target !== 'undefined')? videoplay_target :  'video-player';

	audio_volume =  (typeof audio_volume !== 'undefined')? audio_volume :  '0.5';
	audio_autoplay =  (typeof audio_autoplay !== 'undefined')? audio_autoplay :  false;
	audioplay_id = (typeof audioplay_id !== 'undefined')? audioplay_id :  '.play-audio';
	audioplay_stop = (typeof audioplay_stop !== 'undefined')? audioplay_stop :  '.stop-audio';
  audioplay_target = (typeof audioplay_target !== 'undefined')? audioplay_target :  'audio-player';


	var videoplay_before = false;
  var videoplay_switch_target = false;
	var videoplay_switch_switched = false;
	var audioplay_stopped = false;

	if(videoloop_enable && videoloop_id) {
		if(logit) console.log('[VIDEO LOOP] Enabled: ' + videoloop_id);
		if(logit == 2) console.log('[VIDEO LOOP] Skip first: ' + videoloop_skip_first + ', last: ' + videoloop_skip_last + ' s.');

		var videoloop = document.getElementById(videoloop_id);

		if(videoloop) {
				var videoloop_duration = videoloop.duration;
				videoloop.addEventListener("timeupdate", function () {
						if (!videoloop_duration) {
								videoloop_duration = (videoloop.duration - videoloop_skip_last);
								//if(logit == 2) console.log('[VIDEO LOOP] Clock:' + (videoloop_duration - this.currentTime));
								if(this.currentTime >= videoloop_duration) {
									  if(logit == 2) console.log('[VIDEO LOOP] RELOOP - Duration: ' + videoloop.duration + ' time: ' + this.currentTime);
										this.currentTime = videoloop_skip_first;




								}
						} else {
								videoloop_duration = 0;
								//if(logit == 2) console.log('[VIDEO LOOP] Duration:' + videoloop.duration);
						}
				});
		}
	} else {
		if(logit == 2) console.log('[VIDEO LOOP] Disabled');
		if(logit == 2) console.log('[VIDEO LOOP] add javascript variable videoloop_enable & videoloop_id (html id of video element) to start. Other variables: videoloop_skip_first, videoloop_skip_last');
	}


if(videoplay_id && videoplay_target) {
	if(logit == 2) console.log('[VIDEO PLAY] Enabled');
	$(videoplay_id).click(function( event ) {
			if(logit == 2) console.log('[VIDEO PLAY] Clicked');
			document.getElementById(videoplay_target).play();
		});
}


if(audioplay_id && audioplay_target) {

	$(audioplay_id).click(function( event ) {
			if(logit == 2) console.log('[VIDEO PLAY] Clicked');
			document.getElementById(audioplay_target).play();
			//document.getElementById(audioplay_target).volume = audio_volume;
		});
}

if(audio_volume && audioplay_target) {

	if($("#" + audioplay_target).length == 0) {
	  //it doesn't exist
	} else {
		if(logit == 2) console.log('[AUDIO PLAY] Enabled');
		var audio = document.getElementById(audioplay_target);
		audio.volume = audio_volume;

		$(audioplay_stop).click(function( event ) {
			if(logit == 2) console.log('[AUDIO PLAY] Stopped');
			audioplay_stopped = true;
			document.getElementById(audioplay_target).pause();
			document.getElementById(audioplay_target).volume = 0;
			});

	}


}

if(audioplay_id && audioplay_target && audio_volume && audio_autoplay) {

	if($("#" + audioplay_target).length == 0) {
	  //it doesn't exist
	} else {
		if(logit == 2) console.log('[AUDIO PLAY] Enabled Autoplay');
		var audio = document.getElementById(audioplay_target);
		audio.volume = audio_volume;

		document.getElementById(videofix_autoplay_click_id).click();
		// Play video after click
		setTimeout(function(){
				//document.getElementById(audioplay_target).play();
		}, 1500);


		$('body, body *:not('+audioplay_stop+')').click(function( event ) {
			if(!audioplay_stopped) {
				if(logit == 2) console.log('[AUDIO PLAY] Started');
				document.getElementById(audioplay_target).play();
				document.getElementById(audioplay_target).volume = audio_volume;
			}

			});


	}






}




if(videoplay_switch) {
	if(logit == 2) console.log('[VIDEO PLAY SWITCH] Enabled');
	$(videoplay_switch).click(function( event ) {
			event.preventDefault();
			videoplay_before = '#' + $('video.active').attr('id');
			videoplay_switch_target = $(this).attr('href');

			$(videoplay_switch_target).addClass('active').removeClass('d-none');
			$(videoplay_before).removeClass('active').addClass('d-none');
			$('#play-playing').removeClass('d-none');
			$('#play-start').addClass('d-none');
			$('#play-extras').addClass('d-none');
			var videoswitch_item = document.getElementById(videoplay_switch_target.replace("#", ""));

			if(videoswitch_item) {
				videoswitch_item.play();


				if(audio_volume && audioplay_target && !audioplay_stopped) {

					if($("#" + audioplay_target).length == 0) {
					  //it doesn't exist
					} else {
						if(logit == 2) console.log('[AUDIO PLAY] Started');
						document.getElementById(audioplay_target).play();
            document.getElementById(audioplay_target).volume = audio_volume;
					}


				}


				if(logit == 2) console.log('[VIDEO PLAY SWITCH] Target ' + videoplay_switch_target + ' old ' + videoplay_before);

			var videoswitch_item_duration = videoswitch_item.duration - 1;
			videoswitch_item.addEventListener("timeupdate", function () {
				if(this.currentTime >= videoswitch_item_duration) {
						if(logit == 2) console.log('[VIDEO  PLAY SWITCH] RELOOP');
						$(videoplay_switch_target).removeClass('active').addClass('d-none');
						$(videoplay_before).addClass('active').removeClass('d-none');
						$('#play-playing').addClass('d-none');
						$('#play-extras').removeClass('d-none');
				}

			});
			}



		});
}


	if(videofix_autoplay_enable) {


		//function detectBrowser() {

		let isMobile = window.matchMedia("(pointer:coarse)").matches;

    let userAgent = navigator.userAgent;
    let browserName;

    if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = "Chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = "Firefox";
    } else if (userAgent.match(/safari/i)) {
      browserName = "Safari";
    } else if (userAgent.match(/opr\//i)) {
      browserName = "Opera";
    } else if (userAgent.match(/edg/i)) {
      browserName = "Edge";
    } else if (userAgent.match(/android/i)) {
      browserName = "Android";
    } else if (userAgent.match(/iphone/i)) {
      browserName = "iPhone";
    } else {
      browserName = "Unknown";
    }

    //}

		if(logit == 2) console.log('[VIDEOFIX] running '+ browserName + ' mobile ' +  isMobile);


		if(browserName == "Chrome" && isMobile) {
			if(logit == 1) console.log('[VIDEOFIX] Fixed ');
			// Click a random element
			document.getElementById(videofix_autoplay_click_id).click();
			// Play video after click
			setTimeout(function(){
			    document.getElementById('video').play();
			}, 1500);
		}




	}




	// END JQUERY
});
